import { LogoImage1 } from "@/assets";
import NoData from "@/components/NoData";
import RenderWhen from "@/components/RenderWhen";
import UploadModel from "@/components/upload-model";
import { centerTextEllipsis } from "@/utils";
import { Button, useDisclosure } from "@nextui-org/react";
import Link from "next/link";
import { toast } from "react-toastify";
import useFetchMyModel from "./useFetch";

const ProfileModel = () => {
  const { assetData, loading, handleGetModel } = useFetchMyModel();
  const { isOpen, onOpen, onOpenChange, onClose } = useDisclosure();
  const getTitle = (url: string) => {
    const urlSplit = url.split('/');
    return urlSplit[urlSplit.length - 1];
  }
  const callbackDone = () => {
    onClose(); 
    handleGetModel();
    toast.success('Add model successfully!')
  }

  return (
    <div className="mt-3">
      <div className="flex justify-end mb-4">
        <Button onClick={onOpen} className="rounded-full flex bg-primary text-[14px] h-10 sm:h-[36px] text-white">
          <span className="text-[22px] font-light">+</span> 
          <span className="font-medium sm:text-[13px]">Add Model</span>
        </Button>
        {isOpen && <UploadModel isOpen={isOpen} onOpenChange={onOpenChange} callback={callbackDone} />}
      </div>
      <RenderWhen>
        <RenderWhen.If isTrue={assetData.length === 0 && !loading}>
          <NoData />
        </RenderWhen.If>
        <RenderWhen.If isTrue={assetData.length > 0}>
          <div className="grid grid-cols-6 2xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-4">
            {assetData.map(asset => (
              <>
                <Link target="_blank" className="h-[160px] sm:h-[140px] transition-all hover:shadow-md rounded-md flex flex-col justify-around p-4 sm:p-1 bg-gray-50" href={asset.url}>
                  <div className="flex justify-center">
                    <LogoImage1 />
                  </div>
                  <p className="line-clamp-1 text-gray-600 text-[14px] sm:text-[13px] text-center">ID: {centerTextEllipsis(getTitle(asset.url) ?? '')}</p>
                </Link>
              </>
            ))}
          </div>
        </RenderWhen.If>
      </RenderWhen>
    </div>
  );
}

export default ProfileModel;